'use client';

import type { SessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

class SessionReplayManager {
  private static instance: SessionReplayManager;
  private isInitialized = false;
  private sessionReplayPlugin: SessionReplayPlugin | null = null;

  //eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): SessionReplayManager {
    if (!SessionReplayManager.instance) {
      SessionReplayManager.instance = new SessionReplayManager();
    }
    return SessionReplayManager.instance;
  }

  initialize(sessionReplayPlugin?: SessionReplayPlugin) {
    this.isInitialized = true;
    this.sessionReplayPlugin = sessionReplayPlugin ?? null;
  }

  async flush(): Promise<void> {
    if (!this.isInitialized || !this.sessionReplayPlugin) {
      console.warn(
        'SessionReplayManager: Not initialized or session replay plugin not available, cannot flush',
      );
      return;
    }

    try {
      // Flush session replay data specifically
      await this.sessionReplayPlugin.sessionReplay.flush(true);
      console.log(
        'SessionReplayManager: Successfully flushed session replay data',
      );
    } catch (error) {
      console.error(
        'SessionReplayManager: Failed to flush session replay data',
        error,
      );
    }
  }

  flushSync(): void {
    if (!this.isInitialized || !this.sessionReplayPlugin) {
      console.warn(
        'SessionReplayManager: Not initialized or session replay plugin not available, cannot flush',
      );
      return;
    }

    try {
      // Call session replay flush without awaiting to avoid blocking
      const flushPromise = this.sessionReplayPlugin.sessionReplay.flush(true);
      if (flushPromise && typeof flushPromise.catch === 'function') {
        flushPromise.catch((error: unknown) => {
          console.error(
            'SessionReplayManager: Failed to flush session replay data',
            error,
          );
        });
      }
      console.log(
        'SessionReplayManager: Initiated sync flush of session replay data',
      );
    } catch (error) {
      console.error('SessionReplayManager: Failed to initiate flush', error);
    }
  }
}

export const sessionReplayManager = SessionReplayManager.getInstance();
